import React, {useState} from 'react';
import {Form} from 'react-bootstrap';


export const InputCustom = ({label, name, value, max, min, maxLength, onChange}) => {
    const [val, setVal] = useState(value);
    const [invalid, setInvalid] = useState(false);

    const onFieldChange = (e) => {
        const re = /^[0-9\b]+$/;
        let value = e.currentTarget ? e.currentTarget.value : '';
        if (re.test(value)) {
            value = parseInt(e.currentTarget.value);
            setInvalid(false);
        } else {
            setInvalid(true);
        }
        setVal(value);

        if (value < min) {
            setInvalid(true);
        } else if (value > max) {
            setInvalid(true);
        } else {
            onChange(value);
        }
    };

    return (<Form.Group controlId={name}>
        {label && <Form.Label>{label} {min}-{max}</Form.Label>}
        <Form.Control
            size='lg'
            type='text'
            value={val}
            maxLength={maxLength}
            isInvalid={invalid}
            onChange={onFieldChange}
        />
    </Form.Group>)
};

export const InputCustomString = ({label, name, value, disabled, maxLength, onChange}) => {
    const [val, setVal] = useState(value);
    const [invalid, setInvalid] = useState(false);

    return (<Form.Group controlId={name}>
        {label && <Form.Label>{label}</Form.Label>}
        <Form.Control
            size='lg'
            type='text'
            value={value}
            disabled={disabled}
            maxLength={maxLength}
            isInvalid={invalid}
            onChange={(e) => onChange(e.currentTarget.value)}
        />
    </Form.Group>)
};
